var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #80d4d4;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #00a9a9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 30px;\n      }\n\n      .cls-5 {\n        fill: #bfeaea;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #40bfbf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 600,
    cy: 600.18,
    r: 557.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M861.3,987.31l-199.32-199.32c-1.22-1.22-2.44-2.44-3.48-3.83-9.4-10.45-15.5-22.81-18.29-35.7l.17-.17c-6.27-26.13,1.22-55.21,21.77-75.76,30.3-30.3,79.07-31.7,111.29-3.31,1.39,1.05,2.61,2.27,3.83,3.48l199.32,199.32-115.3,115.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 486.36,
    cy: 475.65,
    r: 262.96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 319.19,
    y1: 610.5,
    x2: 645.87,
    y2: 610.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.05,375.5h-18.55c-12.34,0-22.34,10-22.34,22.34v212.66h63.23v-212.66c0-12.34-10-22.34-22.34-22.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M494.8,289.94h-18.56c-12.34,0-22.34,10-22.34,22.34v298.22h63.24v-298.22c0-12.34-10-22.34-22.34-22.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.55,454.43h-18.56c-12.34,0-22.34,10-22.34,22.34v133.73h63.23v-133.73c0-12.34-10-22.34-22.34-22.34Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.771d302f9a6afa3bdb17722525ea8aa4.svg";
export { ForwardRef as ReactComponent };